export default {
  data() {
    return {
      pagination: {
        sortBy: "created_at",
        descending: true
      }
    };
  },
  watch: {
    pagination: {
      handler() {
        this.fetchItems();
      },
      deep: true
    }
  }
};
